// @flow
import { isNil } from "ramda"
import type { ProductVariantAvailableAffiliate } from "data/product/types"

export const getPriceForDay = (
  a?: ProductVariantAvailableAffiliate,
  daysFromStart: ?number,
): ?number => {
  if (isNil(daysFromStart) || daysFromStart < 0 || !a) return undefined

  if (daysFromStart > a.pricing.length - 1)
    return a.pricing[a.pricing.length - 1]

  return a.pricing[daysFromStart]
}



// WEBPACK FOOTER //
// ./src/components/Calendar/Month/Day/DayPrice/helpers.js